import { render } from "./SpecialPurposeItem.vue?vue&type=template&id=5700cda2&scoped=true&ts=true"
import script from "./SpecialPurposeItem.vue?vue&type=script&lang=ts"
export * from "./SpecialPurposeItem.vue?vue&type=script&lang=ts"

import "./SpecialPurposeItem.vue?vue&type=style&index=0&id=5700cda2&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5700cda2"]])

export default __exports__